import { render, staticRenderFns } from "./Apartments.vue?vue&type=template&id=e8abbc3e&"
import script from "./Apartments.vue?vue&type=script&lang=js&"
export * from "./Apartments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports